import { useEffect } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import PricingPlans from "@/components/pricing/PricingPlans";

export default function PricingPage() {
  useEffect(() => {
    // Set page title
    document.title = "Pricing | Habitualy";
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <PricingPlans />
      </main>
      <Footer />
    </div>
  );
} 